import { render, staticRenderFns } from "./DragDrop.vue?vue&type=template&id=161705e3&scoped=true&"
import script from "./DragDrop.vue?vue&type=script&lang=js&"
export * from "./DragDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragDrop.vue?vue&type=style&index=0&id=161705e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161705e3",
  null
  
)

export default component.exports